import React, { useCallback } from "react";
import { useBookingModalContext } from "processes/Booking/components/BookingModal/BookingModalContext";
import BookingInsurance from "processes/Booking/BookingInsurance/BookingInsurance";
import { GoodsamInsuranceModal } from "components/GoodsamInsuranceModal";

const InsurancePlan = ({ showBookingInsuranceModal, setShowBookingInsuranceModal }) => {
  const {
    rvData,
    rentalType,
    insuranceId,
    setInsuranceId,
    setIsModalHidden
  } = useBookingModalContext();

  const toggleOpen = useCallback(() => {
    setShowBookingInsuranceModal((p) => !p);
    setIsModalHidden((p) => !p);
  }, [setIsModalHidden, setShowBookingInsuranceModal]);

  const onSave = useCallback(
    (currentPlan) => {
      setInsuranceId(currentPlan.id);
      toggleOpen();
    },
    [setInsuranceId, toggleOpen]
  );

  return (
    <>
      {showBookingInsuranceModal && (
        <GoodsamInsuranceModal
          rvId={rvData.id}
          show={showBookingInsuranceModal}
          onClose={toggleOpen}
          selectedPlanId={insuranceId}
          onSelectPlan={onSave}
          rentalType={rentalType}
          backTo="Back to booking"
        />
      )}
    </>
  );
};

export default InsurancePlan;
